"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HelpRequestDirective = /** @class */ (function () {
    function HelpRequestDirective() {
        return {
            restrict: 'A',
            link: function (scope, element) {
                element.click(function () { });
            }
        };
    }
    HelpRequestDirective.create = function () {
        return new HelpRequestDirective();
    };
    return HelpRequestDirective;
}());
exports.HelpRequestDirective = HelpRequestDirective;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGVscFJlcXVlc3QuZGlyZWN0aXZlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiaGVscFJlcXVlc3QuZGlyZWN0aXZlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUE7SUFDSTtRQUNJLE9BQU87WUFDSCxRQUFRLEVBQUUsR0FBRztZQUNiLElBQUksWUFBQyxLQUFLLEVBQUUsT0FBTztnQkFDZixPQUFPLENBQUMsS0FBSyxDQUFDLGNBQWEsQ0FBQyxDQUFDLENBQUM7WUFDbEMsQ0FBQztTQUNKLENBQUE7SUFDTCxDQUFDO0lBRU0sMkJBQU0sR0FBYjtRQUNJLE9BQU8sSUFBSSxvQkFBb0IsRUFBRSxDQUFDO0lBQ3RDLENBQUM7SUFDTCwyQkFBQztBQUFELENBQUMsQUFiRCxJQWFDO0FBYlksb0RBQW9CIn0=